import { FC, ReactNode } from 'react';

import { Typography } from '../../../typography/components/Typography/Typography';

interface Props {
   align?: 'left' | 'center' | 'right';
   children: ReactNode;
   colSpan?: number;
   verticalAlign?: 'top' | 'middle' | 'baseline' | 'bottom';
   width?: string;
   sticky?: boolean;
   stickyOffset?: string;
}

export const TableSubheader: FC<Props> = ({ align = 'left', colSpan = 1, verticalAlign = 'middle', width, sticky = false, stickyOffset = '0', children }) => (
   <td
      data-testid="table-subheader"
      align={align}
      colSpan={colSpan}
      valign={verticalAlign}
      width={width}
      style={sticky ? { position: 'sticky', left: stickyOffset, zIndex: 2 } : undefined}
      className="bg-component-data-display-table-cell-color-background-subheader py-component-layout-box-spacing-padding-edge-to-element-vertical-lg px-component-layout-box-spacing-padding-edge-to-text-horizontal-lg snap-start whitespace-normal"
   >
      <Typography variant="body" color="strong">
         {children}
      </Typography>
   </td>
);
